import { render, staticRenderFns } from "./TooltipChip.vue?vue&type=template&id=b815c56a&scoped=true&"
import script from "./TooltipChip.vue?vue&type=script&lang=ts&"
export * from "./TooltipChip.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipChip.vue?vue&type=style&index=0&id=b815c56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b815c56a",
  null
  
)

export default component.exports